import type { AirtimeContact } from '@/types/portal';

/**
 * Lines a finance user tops up with airtime. The favourites ship pinned so the
 * Buy Airtime screen opens with the numbers this agency recharges most often.
 */
export const airtimeContacts: AirtimeContact[] = [
  { id: 'air-amina', name: 'Peter (Me)', number: '254799402657', favourite: true },
  { id: 'air-grace', name: 'Grace Kim', number: '254722908877', favourite: true },
  { id: 'air-field-ops', name: 'Field Ops Line', number: '254711223344', favourite: true },
  { id: 'air-nairobi-desk', name: 'Nairobi Desk', number: '254733114422', favourite: true },
  { id: 'air-kampala', name: 'Kampala Desk', number: '256772445566', favourite: false },
  { id: 'air-dar', name: 'Dar es Salaam Desk', number: '255712998877', favourite: false },
  { id: 'air-courier', name: 'Courier Runner', number: '254701556677', favourite: false },
  { id: 'air-studio', name: 'Studio Hotline', number: '254790112233', favourite: false },
];

/** The agency's own registered line, used when topping up "Own Number". */
export const ownAirtimeNumber = '254799402657';

/** Airtime amounts offered as one-tap presets on the top-up form. */
export const airtimePresets = [50, 100, 200, 500, 1000];

/** Smallest airtime top-up the portal will accept. */
export const airtimeMinimum = 1;